<template>
  <div class="uploadStatement">
    <div class="header">
      <div class="title">
        {{ satementData.reconciliationName }}
      </div>
    </div>
    <div class="content">
      <div class="firstTable">
        <div class="tableHead">
          <div class="headItem"></div>
          <div class="headItem">记录数合计</div>
          <div class="headItem">保费合计</div>
          <div class="headItem">费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期限时加费合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续年服务津贴合计</div>
        </div>
        <div class="tableRow">
          <div class="header">系统</div>
          <div class="rowItem">{{ summaryData.totalNumber || 0 }}</div>
          <div class="rowItem">{{ summaryData.totalFee || 0 }}</div>
          <div class="rowItem">{{ summaryData.totalCommission || 0 }}</div>
          <div class="rowItem" v-if="satementData.reconciliationType == 1">{{ summaryData.totalBaseCommission || '0' }}
          </div>
          <div class="rowItem" v-if="satementData.reconciliationType == 1">{{ summaryData.totalActCommission || '0' }}
          </div>
          <div class="rowItem" v-if="satementData.reconciliationType == 4">{{ summaryData.totalRenewBaseCommission || '0'
          }}
          </div>
          <div class="rowItem" v-if="satementData.reconciliationType == 4">{{ summaryData.totalRenewAllowance || '0' }}
          </div>
        </div>
        <div class="tableRow">
          <div class="header">供应商</div>
          <div class="rowItem">-</div>
          <div class="rowItem">-</div>
          <div class="rowItem">-</div>
          <div class="rowItem" v-if="satementData.reconciliationType == 1 || satementData.reconciliationType == 4">-</div>
          <div class="rowItem" v-if="satementData.reconciliationType == 1 || satementData.reconciliationType == 4">-</div>
        </div>
      </div>
      <div class="search-tools">
          <div class="search-box btn3">
            <div class="input-item">
              <span class="label">保单号</span>
              <Input v-model="searchData.policyNo" placeholder="请输入" clearable />
            </div>
            <Button type="primary" @click="getList()">搜索</Button>
          </div>
        </div>
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="commissionType">
          <span v-if="(row.commissionType == 1||row.commissionType == 3)&&row.commissionIndex > 1">续期基础费用</span>
          <span v-else-if="row.commissionType == 1||row.commissionType == 3">基础费用</span>
          <span v-else-if="[2, 4, 11, 12, 20].includes(row.commissionType * 1)" style="position: relative;">限时加费活动
            <Tooltip transfer>
              <i class="tip-icon">?</i>
              <template #content>
                <div>{{ row.activityName }}</div>
                <span>{{ '(' +  row.activityBegin+ '至'+ row.activityEnd+ ')' }}</span>
            </template>
            </Tooltip>
          </span>
          <span v-else-if="row.commissionType == 5">后置费用</span>
          <span v-else-if="row.commissionType == 13||row.commissionType == 14||row.commissionType == 19">梯度加费</span>
          <span v-else-if="row.commissionType == 15||row.commissionType == 16">续年服务津贴</span>
          <span v-else-if="row.commissionType == 17||row.commissionType == 18">继续率费用</span>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange"
          style="text-align: center" />
      </div>
    </div>
    <div class="footer">
      <div>
        <Button type="primary" ghost @click="back(backUrl)">返回</Button>
        <Button type="primary" ghost @click.stop="lastStep()">上一步</Button>
        <Button type="primary" ghost @click="daochu()">导出系统清单</Button>
        <Upload ref="upload" :show-upload-list="false" class="upload-btn" :max-size="2048" :data="uploadParams"
          :before-upload="handleBeforeUpload" action="/">
          <Button type="primary" ghost>上传供应商结算单</Button>
        </Upload>
        <Button type="primary" ghost @click="downloadTemplate">下载供应商结算单模版</Button>
      </div>
    </div>
    <uploadModal ref="uploadModal"></uploadModal>
  </div>
</template>

<script>
import { pageTool,common } from "@/api/mixins";
import uploadModal from "./uploadModal.vue"
export default {
  props: ['checkId'],
  mixins: [pageTool,common],
  components: { uploadModal },
  data() {
    return {
      satementData: {
        reconciliationName: ''
      },// 对账单数据
      pageNo: 1,
      backUrl: '', //返回链接
      searchData:{},
      summaryData: {
        totalNumber: '',
        totalFee: '',
        totalFeePremiums: '',
        totalFeeNonPremiums: '',
        totalCommission: ''
      },// 系统汇总数据
      columns: [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          width: "200",
        },
        {
          title: "保单年度",
          width: 100,
          key: "commissionIndex",
          align: "center",
        },
        {
          title: '交费期次',
          key: 'commissionPeriods',
          align: 'center',
          width: "100",
        },
        {
          title: '保险产品',
          key: 'productName',
          align: 'center',
          width: "200",
        },
        {
          title: '险种名称',
          key: 'productTypeName',
          align: 'center',
          width: "200",
        },
        {
          title: '保单状态',
          key: 'policyStatus',
          align: 'center',
          width: "100",
        },
        {
          title: '承保日期',
          key: 'insureTime',
          align: 'center',
          width: "200",
        },
        {
          title: '生效日期',
          key: 'effectTime',
          align: 'center',
          width: "200",
        },
        {
          title: '实收日期',
          key: 'actualReceiveTime',
          align: 'center',
          width: "200",
        },
        {
          title: '保障期',
          key: 'guaranteeValueDesc',
          align: 'center',
          width: "100",
        },
        {
          title: '交费期',
          key: 'payValueDesc',
          width: "100",
          align: 'center',
        },
        {
          title: "费用类型",
          align: "center",
          minWidth: 140,
          tooltip: true,
          slot:'commissionType'
        },
        {
          title: '保费',
          align: 'center',
          children: [
            {
              title: '系统保费',
              key: 'fee',
              width: "200",
              align: 'center',
            },
            {
              title: '供应商保费',
              key: 'supplierFee',
              width: "200",
              align: 'center',
            },
          ]
        },
        {
          title: '费率',
          align: 'center',
          children: [
          {
              title: '系统费率',
              key: 'commission',
              align: 'center',
              width: "120",
              render(h, params) {
                  return <span>{Number(params.row.commission) ? params.row.commission : '-'}</span>;
              }
            },
            {
              title: '供应商费率',
              key: 'supplierCommission',
              align: 'center',
              width: "120",
              render(h, params) {
                  return <span>{Number(params.row.supplierCommission) ? params.row.supplierCommission : '-'}</span>;
              }
            },
          ]
        },
        {
          title: '费用',
          align: 'center',
          children: [
            {
              title: '系统费用',
              key: 'commissionPrice',
              align: 'center',
              width: "200",
            },
            {
              title: '供应商费用',
              key: 'supplierCommissionPrice',
              align: 'center',
              width: "200",
            },
          ]
        },
      ],
      tabelData: [],
      uploadParams: {
        checkId: this.$route.query.id || this.checkId
      },
      fileFormat: ['xls', 'XLS'],
    }
  },
  mounted() {
    this.backUrl = this.$route.query.backUrl;
    this.detail()
    this.getList()
  },
  methods: {
    daochu() {
      if(this.$units.pointAction('offline_8_1_5')){
        this.loading = true;
        this.$http({
          url: "/buz/molCommissionConsult/exportSysPolicy",
          type: "GET",
          responseType: "blob",
          data: {
            checkId: this.$route.query.id || this.checkId,
          },
        })
          .then((res) => {
            this.loading = false;
            this.$units.daochu(res);
          })
          .catch((e) => {
            this.loading = false;
          });
        }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    downloadTemplate() {
      this.$http({
        url: "/buz/molCommissionConsult/downloadTemplate",
        type: "GET",
        data: { checkId: this.$route.query.id || this.checkId },
      }).then((res) => {
        this.$units.downloadFile(res.data, { checkId: this.$route.query.id || this.checkId }, 'GET', '供应商结算单导入模板.xls');
      });

    },
    handleBeforeUpload(file) {
      if(this.$units.pointAction('offline_8_1_2')){
        const format = file.name.split("\.").pop();
        if (!this.fileFormat.includes(format)) {
          this.$notice.msg("请上传" + this.fileFormat.join(",") + "格式的文件")
          return false;
        }
        let formData = new FormData();
        formData.append("file", file);
        const params = this.uploadParams
        if (params) {
          for (const key in params) {
            if (Object.hasOwnProperty.call(params, key)) {
              const element = params[key];
              formData.append(key, element);
            }
          }
        }
        this.$http({
          type: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          url: '/buz/molCommissionSettlementUpload/importDataExcel',
          data: formData
        }).then(res => {
          if(!res.data) {
            this.$notice.error('数据异常');
            return;
          }
          if(res.data.length) {
            // 下载异常文件
            this.$units.downloadFile('/buz/molCommissionSettlementUpload/exportErrorData', {
              checkId: this.uploadParams.checkId,
              dataList: res.data
            }, 'POST')
            this.$notice.error('上传失败，异常文件信息已为您自动下载');
          } else {
            this.$notice.success('上传成功');
            this.nextStep()
          }
        })
        return false;
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    getList() {
      this.$http({
        url: '/buz/molCommissionConsult/detailsPageByCheckId',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId,
          policyNo:this.searchData.policyNo,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.getSummaryData()
      })
    },
    detail() {
      this.$http({
        url: "/buz/commissionReconciliation/read/detail",
        type: "GET",
        data: { id: this.$route.query.id || this.checkId },
      }).then((res) => {
        this.satementData = res.data
        // 只有续期有保单年度
        if (this.satementData.reconciliationType != 4) {
          this.columns.forEach((el, i) => {
            if (el.key == "commissionIndex") {
              this.columns.splice(i, 1);
            }
          });
        }
        if(this.satementData.reconciliationType == 1 || this.satementData.reconciliationType ==2){
          let idx = ''
          idx = this.columns.findIndex(item => item.key == 'effectTime')
          this.columns.splice(idx, 1);
          idx = this.columns.findIndex(item => item.key == 'actualReceiveTime')
          this.columns.splice(idx, 1);
        }
      });
    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList()
    },
    //获取汇总数据
    getSummaryData() {
      this.$http({
        url: '/buz/molCommissionConsult/summaryTabs',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId
        },
      }).then((res) => {
        if (res.data) {
          this.summaryData = res.data[0]
        }
      })
    },
    lastStep() {
      this.$emit('lastStep')
      this.$http({
        url: '/buz/commissionReconciliation/edit',
        type: 'POST',
        data: {
          step: 1,
          id: this.$route.query.id || this.checkId,
          agreementId:this.satementData.agreementId
        },
      })
    },
    nextStep() {
      this.$emit('nextStep')
      this.$http({
        url: '/buz/commissionReconciliation/edit',
        type: 'POST',
        data: {
          step: 3,
          id: this.$route.query.id || this.checkId,
          agreementId:this.satementData.agreementId
        },
      })
    }
  }
}
</script>

<style lang="scss" scoped>@import "./uploadStatement.scss"</style>